
import WidgetDefaultNuxt from '../default/nuxt.vue';

export default {
  name: 'WidgetInputNuxt',

  extends: WidgetDefaultNuxt,

  data() {
    const { values, getLocaleValue } = this;
    this.timer = null;

    return {
      max: values.max || 1000,
      min: values.min || 0,
      maxlength: values.maxlength || 1000,
      minlength: values.minlength || 0,
      type: values.inputType,
      placeholder: getLocaleValue(values.placeholder),
      disabled: values.disabled || false,
      readonly: values.readonly || false,
      autocomplete: values.autocomplete || 'off',
      defaultValue: getLocaleValue(values.defaultValue),
      isFocusing: false,
      isCompositing: false,
      // localePath: [ // TODO 关联数据池的需要加监听修改逻辑
      //   { key: 'placeholder', value: values.placeholder },
      //   { key: 'defaultValue', value: values.defaultValue },
      // ],
    };
  },

  computed: {
    extraProps() {
      const props = {};
      if (this.type === 'number') {
        props.max = this.max;
        props.min = this.min;
      } else {
        props.maxlength = this.maxlength;
        props.minlength = this.minlength;
      }
      return props;
    },

    inputClasses() {
      const classes = this.classes || {};
      return [
        'widget-input',
        this.isFocusing && 'widget-input-focus',
        {
          ...classes,
        },
      ];
    },

    mergedStyles() {
      // const styles = {};
      // const values = this.values || {};
      // const customBg = values.background || [];
      // const customEffect = values['custom-effect'] || [];
      // const transprentRegex = /^rgba\([0-9,\s]*,\s0\)$/;
      // const hasCustomBg = customBg.some(
      //   (item) => this.isString(item) || item?.opacity > 0
      // );
      // const hasCustomEffect = customEffect.some(
      //   (item) =>
      //     item?.type === 'box-shadow' && !transprentRegex.test(item?.color)
      // );

      // if (hasCustomBg) {
      //   styles.background = 'transparent';
      // }

      // if (hasCustomEffect) {
      //   styles['box-shadow'] = 'none';
      // }

      return {
        // ...styles,
        ...this.localeStyles,
      };
    },
  },

  mounted() {
    if (this.isLegal(this.defaultValue)) {
      this.handleInput(this.defaultValue);
    }
  },

  beforeDestroy() {
    this.clearTimer();
  },

  methods: {
    isString(target) {
      return typeof target === 'string';
    },

    initEvent() {
      this.rocketOn('rocket:input:set-value', true, (value) => {
        this.setValue(value);
      });
      this.rocketOn('rocket:input:set-disabled', true, (status) => {
        this.disabled = status === 'true';
      });
      this.rocketOn('rocket:input:set-readonly', true, (status) => {
        this.readonly = status === 'true';
      });
      this.rocketOn('rocket:input:do-focus', true, () => {
        this.doFocus();
      });
    },
    setValue(value) {
      const formattedValue = this.formatValue(value);
      this.$refs.inputRef.value = formattedValue;
    },

    onFocus() {
      this.isFocusing = true;
      this.rocketEmit('rocket:input:focus', true);
    },

    onBlur() {
      this.isFocusing = false;
      this.rocketEmit('rocket:input:blur', true);
    },

    clearTimer() {
      this.timer && clearTimeout(this.timer);
    },

    onInput(e) {
      if (this.isCompositing) return;
      this.clearTimer();
      this.timer = setTimeout(() => {
        this.handleInput(e.target.value);
      }, 100);
    },

    doFocus() {
      this.$refs.inputRef && this.$refs.inputRef.focus();
    },

    isLegal(target) {
      return target || target === 0;
    },

    formatValue(value) {
      if (!this.isLegal(value)) return value;

      let result = value;

      if (this.type === 'number') {
        const max = this.max;
        const min = this.min;
        if (this.isLegal(max)) {
          result = result > max ? max : result;
        }
        if (this.isLegal(min)) {
          result = result < min ? min : result;
        }
      } else {
        const max = this.maxlength;
        if (this.isLegal(max)) {
          result = result.length > max ? result.slice(0, max) : result;
        }
      }

      return result;
    },

    handleInput(val) {
      let value = val;
      if (this.isLegal(value)) {
        if (this.type === 'number') {
          value = Number(value);
        }
      } else {
        value = this.defaultValue;
      }
      value = this.formatValue(value);
      this.setValue(value);
      this.rocketEmit('rocket:input:change', true, value);
    },

    handleCompositionStart(e) {
      this.isCompositing = true;
    },

    handleCompositionEnd(e) {
      this.isCompositing = false;
      this.handleInput(e.target.value);
    },
  },
};
